import { useEffect, useState, useRef } from "react";
import { User } from "../interfaces/User";
import { useNavigate } from "react-router-dom";
import EditProfile from "./EditProfile";
import { useTranslation } from "react-i18next";
import { handleApiError, safeJsonParse } from "../../utils/api";

export default function UserTeaser() {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const [currentUser, setCurrentUser] = useState<User>();
    const [showEditProfile, setShowEditProfile] = useState(false);
    const [showMobileDropdown, setShowMobileDropdown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleLogout = () => {
        localStorage.setItem('token', '');
        localStorage.setItem('userId', '');
        localStorage.setItem('userRole', '');
        localStorage.setItem('userEmail', '');
        localStorage.setItem('isAdmin', '');
        setShowMobileDropdown(false);
        navigate("/");
    }

    const handleOpenEditProfile = () => {
        setShowEditProfile(true);
        setShowMobileDropdown(false);
    }

    const handleCloseEditProfile = () => {
        setShowEditProfile(false);
    }

    const toggleMobileDropdown = () => {
        setShowMobileDropdown(!showMobileDropdown);
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowMobileDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/user/' + userId, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                setCurrentUser(data);
            });
    }, []);

    return(
        <div className="user-teaser" ref={dropdownRef}>
            <div className="image-container" onClick={toggleMobileDropdown}>
                { currentUser && currentUser.profile.avatar &&
                    <img src={ currentUser.profile.avatar } alt={ currentUser.profile.firstname + ' ' + currentUser.profile.lastname } />
                }
                { !currentUser || !currentUser.profile.avatar &&
                    <div className="avatar"></div>
                }
            </div>
            <div className="text-container">
                <div className="name">
                    { currentUser && (currentUser.profile.firstname || currentUser.profile.lastname) &&
                        currentUser.profile.firstname + ' ' + currentUser.profile.lastname
                    }
                    { currentUser && !(currentUser.profile.firstname || currentUser.profile.lastname) &&
                        currentUser.email
                    }
                </div>
                <div className="actions">
                    <a onClick={ handleOpenEditProfile } title={ t("Update profile") }>{ t("Profile") }</a>
                    <a onClick={ handleLogout } title={ t("Logout your taskGen session") }>{ t("Logout") }</a>
                </div>
            </div>
            {showMobileDropdown && (
                <div className="mobile-dropdown">
                    <div className="mobile-dropdown-name">
                        { currentUser && (currentUser.profile.firstname || currentUser.profile.lastname) &&
                            currentUser.profile.firstname + ' ' + currentUser.profile.lastname
                        }
                        { currentUser && !(currentUser.profile.firstname || currentUser.profile.lastname) &&
                            currentUser.email
                        }
                    </div>
                    <div className="mobile-dropdown-actions">
                        <a onClick={ handleOpenEditProfile } title={ t("Update profile") }>{ t("Profile") }</a>
                        <a onClick={ handleLogout } title={ t("Logout your taskGen session") }>{ t("Logout") }</a>
                    </div>
                </div>
            )}
            { showEditProfile && <EditProfile closeCallback={ handleCloseEditProfile } />}
        </div>
    );
}